import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-be06ccc6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "deposit-stake" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
import BigNumber from 'bignumber.js';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        initializeAmount: null,
        label: null,
        minInput: null,
        maxInput: null,
        step: null,
        decimal: null,
        disabled: { type: Boolean }
    },
    emits: ["setAmount", "keyPress"],
    setup(__props, { emit }) {
        const props = __props;
        const amount = ref(props.initializeAmount);
        const onChangeStake = (value) => {
            emit('setAmount', BigNumber(value).dp(props.decimal).toNumber());
        };
        const onIncrement = () => {
            if (amount.value < props.minInput && props.maxInput) {
                amount.value = props.minInput;
                emit('setAmount', amount.value);
                return;
            }
            const amountHolder = BigNumber(amount.value).plus(props.step).dp(props.decimal).toNumber();
            amount.value = Math.min(amountHolder, props.maxInput);
            emit('setAmount', amount.value);
        };
        const onDecrement = () => {
            const amountHolder = BigNumber(amount.value).minus(props.step).dp(props.decimal).toNumber();
            amount.value = Math.max(amountHolder, props.minInput);
            emit('setAmount', amount.value);
        };
        const reInit = () => {
            emit('keyPress');
        };
        const limitDecimal = (value) => {
            if (value > 0) {
                amount.value = Number(value.toFixed(props.decimal));
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.step > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(props.disabled ? 'btn-disabled' : ''),
                        onClick: _cache[0] || (_cache[0] = ($event) => (onDecrement())),
                        disabled: __props.disabled
                    }, " - ", 10, _hoisted_2))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(__props.disabled ? 'field-disabled' : ''),
                    type: "number",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((amount).value = $event)),
                    onChange: _cache[2] || (_cache[2] = ($event) => (onChangeStake(amount.value))),
                    onKeypress: reInit,
                    onInput: _cache[3] || (_cache[3] = ($event) => (limitDecimal(amount.value))),
                    disabled: props.disabled
                }, null, 42, _hoisted_3), [
                    [_vModelText, amount.value]
                ]),
                (props.step > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: _normalizeClass(props.disabled ? 'btn-disabled' : ''),
                        onClick: _cache[4] || (_cache[4] = ($event) => (onIncrement())),
                        disabled: __props.disabled
                    }, " + ", 10, _hoisted_4))
                    : _createCommentVNode("", true),
                _createElementVNode("span", null, [
                    _createElementVNode("span", null, _toDisplayString(props.label), 1)
                ])
            ]));
        };
    }
});
